/* eslint-disable no-undef */
import $ from "jquery";

const CheckoutSpecialist = () => {
    const init = () => {
        checkoutAjax();
    };

    const checkoutAjax = () => {
        $(document).on("click", "#js_btn_checkout_specialist", function () {
            const data = {
                action: themeObj.specialist.action.checkout,
                nonce: themeObj.specialist.nonce,
                form_data: $("#js_form_checkout_specialist").serialize(),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    const link = $("#js_link_live").val();
                    window.location.href = link;
                })
                .fail((response) => {
                    console.error(response);
                });
        });
    };

    init();
};

try {
    CheckoutSpecialist();
} catch (error) {
    console.error(error);
}
